import React from 'react';
import { cn } from '../../lib/utils';
import { motion } from 'framer-motion';

export const Section = React.forwardRef(
  ({ className, children, variant = 'default', animate = true, ...props }, ref) => {
    const variantClasses = {
      default: 'bg-white dark:bg-gray-900',
      gray: 'bg-gray-50 dark:bg-gray-800',
      gradient: 'bg-gradient-to-br from-orange-50 via-white to-orange-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900',
      primary: 'bg-gradient-to-r from-orange-600 to-orange-500',
    };

    const baseClasses = cn(
      'py-16 sm:py-20 lg:py-24',
      variantClasses[variant],
      className
    );

    if (animate) {
      return (
        <motion.section
          ref={ref}
          className={baseClasses}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          {...props}
        >
          {children}
        </motion.section>
      );
    }

    return (
      <section ref={ref} className={baseClasses} {...props}>
        {children}
      </section>
    );
  }
);

Section.displayName = 'Section';

export default Section;
